var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: "23px",
    height: "23px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 A 3 3 0 0 0 5 4 A 1 1 0 0 0 7 4 A 1 1 0 0 1 8 3 L 26 3 A 1 1 0 0 1 27 4 L 27 22 A 1 1 0 0 1 26 23 A 1 1 0 0 0 26 25 A 3 3 0 0 0 29 22 L 29 4 A 3 3 0 0 0 26 1 L 8 1 z M 4 6 A 3 3 0 0 0 1 9 L 1 26 A 3 3 0 0 0 4 29 L 21 29 A 3 3 0 0 0 24 26 L 24 9 A 3 3 0 0 0 21 6 L 4 6 z M 4 8 L 21 8 A 1 1 0 0 1 22 9 L 22 26 A 1 1 0 0 1 21 27 L 4 27 A 1 1 0 0 1 3 26 L 3 9 A 1 1 0 0 1 4 8 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.06d382325eca75fb1ac3238229ad2608.svg";
export { ForwardRef as ReactComponent };